import React, { useState, Suspense, useMemo } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Canvas } from "@react-three/fiber";
import { Center, OrbitControls, useGLTF } from "@react-three/drei";
import SteelVariants304Lv2Model from "../Assets/3dImages/304l.glb";
import SteelVariants310v2Model from "../Assets/3dImages/310.glb";
import SteelVariants316v3Model from "../Assets/3dImages/316.glb";
import SteelVariants321Hv3Model from "../Assets/3dImages/321.glb";
import SteelVariants321v3Model from "../Assets/3dImages/321H.glb";
import SteelVariantsALLOY20v3Model from "../Assets/3dImages/alloy20.glb";
import SteelVariantsHASTELLOYv3Model from "../Assets/3dImages/hastelloy.glb";
import SteelVariantsINCONELv3Model from "../Assets/3dImages/inconel.glb";
import SteelVariantsMONELv3Model from "../Assets/3dImages/monel.glb";
import SteelVariantstitaniumv2Model from "../Assets/3dImages/titanium.glb";

const steelVariants = [
  { id: 1, model: SteelVariants304Lv2Model },
  { id: 2, model: SteelVariants310v2Model },
  { id: 3, model: SteelVariants316v3Model },
  { id: 4, model: SteelVariants321Hv3Model },
  { id: 5, model: SteelVariants321v3Model },
];

const exoticMetals = [
  { id: 6, model: SteelVariantsALLOY20v3Model },
  { id: 7, model: SteelVariantsHASTELLOYv3Model },
  { id: 8, model: SteelVariantsINCONELv3Model },
  { id: 9, model: SteelVariantsMONELv3Model },
  { id: 10, model: SteelVariantstitaniumv2Model },
];

function Model({ modelPath }) {
  const gltf = useGLTF(modelPath);
  const modelScene = useMemo(() => gltf.scene.clone(), [gltf.scene]);

  return (
    <Center>
      <primitive object={modelScene} scale={50} />
    </Center>
  );
}

const OurVision = () => {
  const [activeSteelModel, setActiveSteelModel] = useState(
    steelVariants[0].model
  );
  const [activeExoticModel, setActiveExoticModel] = useState(
    exoticMetals[0].model
  );

  const settings = {
    speed: 500, useCSS: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplaySpeed: 3000,
    autoplay: true,
    beforeChange: (_, next) => {
      setActiveSteelModel(steelVariants[next]?.model);
    },
  };

  const exoticSettings = {
    ...settings,
    beforeChange: (_, next) => {
      setActiveExoticModel(exoticMetals[next]?.model);
    },
  };

  return (
    <div className="about-info-container">
      <p className="title-text-about" id="material-component">
        Premium Materials for Unmatched Quality
      </p>
      <p className="description-text text-center">
        In our pursuit of perfection, we use only the finest materials,
        including:
      </p>
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        <h5 className="text-center">
          <li>
            <b>Stainless Steel Variants: </b>
          </li>
        </h5>
        <Slider {...settings}>
          {steelVariants.map((item) => (
            <div key={item.id} className="model-container">
              {activeSteelModel === item.model && (
                <Canvas shadows camera={{ position: [0, 1, 5], fov: 10 }}>
                  <ambientLight intensity={0.5} />
                  <directionalLight
                    position={[-2, 3, 2]}
                    intensity={5}
                    castShadow
                    shadow-mapSize-width={2048}
                    shadow-mapSize-height={2048}
                  />
                  <spotLight
                    position={[0, 4, 4]}
                    intensity={10}
                    angle={0.2}
                    penumbra={0.8}
                    castShadow
                  />
                  <pointLight position={[0, 1, 3]} intensity={5} />
                  <OrbitControls enableZoom minDistance={3} maxDistance={10} />
                  <Suspense fallback={<>Loading Model...</>}>
                    <Model modelPath={item.model} />
                  </Suspense>
                </Canvas>
              )}
            </div>
          ))}
        </Slider>

        <h5 className="text-center">
          <li>
            <b>Exotic Metals: </b>
          </li>
        </h5>
        <Slider {...exoticSettings}>
          {exoticMetals.map((item) => (
            <div key={item.id} className="model-container">
              {activeExoticModel === item.model && (
                <Canvas shadows camera={{ position: [0, 1, 5], fov: 10 }}>
                  <ambientLight intensity={0.5} />
                  <directionalLight
                    position={[-2, 3, 2]}
                    intensity={5}
                    castShadow
                    shadow-mapSize-width={2048}
                    shadow-mapSize-height={2048}
                  />
                  <spotLight
                    position={[0, 4, 4]}
                    intensity={10}
                    angle={0.2}
                    penumbra={0.8}
                    castShadow
                  />
                  <pointLight position={[0, 1, 3]} intensity={5} />
                  <OrbitControls enableZoom minDistance={3} maxDistance={10} />
                  <Suspense fallback={<>Loading Model...</>}>
                    <Model modelPath={item.model} />
                  </Suspense>
                </Canvas>
              )}
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default OurVision;
